/**
 * Работа бота, делегированная сервером этому исполнителю: браузер
 * (OnlineBotRunner), MCP-клиент (server/mcp/gameClient.js), e2e-харнессы.
 *
 * Сервер выдает работу соединению: DELEGATE_BOT_WORK уходит в конкретный сокет
 * участника, и делегатом сервер его считает, пока этот сокет жив. Поэтому
 * работа привязана к сокету, который ее доставил, и исполняется, только пока он
 * текущий и открыт. Работа, полученная до переподключения, больше не
 * исполняется:
 *  - сервер заметил обрыв — работу уже отдали другому исполнителю (или ходит
 *    сам сервер), и продолжение было бы вторым ходом за того же бота;
 *  - не заметил (старый сокет умер молча, новое подключение его вытеснило) —
 *    сервер по-прежнему считает делегатом этого участника и присылает работу
 *    заново, уже в новый сокет (см. decideBotWorkOnMemberReconnect).
 */

// OPEN у WebSocket браузера, пакета ws и глобального WebSocket Node — одно и то
// же значение; сравниваем с литералом, чтобы помощник не зависел от окружения
const SOCKET_OPEN = 1;

export const DELEGATED_WORK_DROP_REASONS = {
  NO_WORK: 'no-work',
  SOCKET_REPLACED: 'socket-replaced',
  SOCKET_NOT_OPEN: 'socket-not-open',
  WORK_KEY_CHANGED: 'work-key-changed',
};

/**
 * Привязать пришедшую работу к доставившему ее сокету. Новая работа всегда
 * заменяет прежнюю — в том числе с тем же ключом: именно так сервер возвращает
 * работу после переподключения, и привязка к новому сокету обязательна
 */
export const bindDelegatedBotWork = (payload, socket) => {
  if (!payload || !payload.workKey) {
    return null;
  }
  return {...payload, socket: socket || null};
};

/**
 * Решение очередного шага исполнителя: {execute, reason}. reason — причина,
 * по которой работу пора снять (null, если шаг делать)
 */
export const getDelegatedBotWorkTickDecision = (work, {currentSocket, currentWorkKey}) => {
  if (!work) {
    return {execute: false, reason: DELEGATED_WORK_DROP_REASONS.NO_WORK};
  }
  if (!work.socket || work.socket !== currentSocket) {
    return {execute: false, reason: DELEGATED_WORK_DROP_REASONS.SOCKET_REPLACED};
  }
  if (currentSocket.readyState !== SOCKET_OPEN) {
    return {execute: false, reason: DELEGATED_WORK_DROP_REASONS.SOCKET_NOT_OPEN};
  }
  if (currentWorkKey !== work.workKey) {
    return {execute: false, reason: DELEGATED_WORK_DROP_REASONS.WORK_KEY_CHANGED};
  }
  return {execute: true, reason: null};
};

/**
 * Работа после REVOKE_BOT_WORK: снимается только работа с тем же ключом
 */
export const getDelegatedBotWorkAfterRevoke = (work, revokePayload) => {
  if (work && revokePayload?.workKey && work.workKey === revokePayload.workKey) {
    return null;
  }
  return work;
};
